import styled from 'styled-components';
import {warpButtons} from '../../designLandingPopup/DesignLandingPopup.css';
import {LIGHT_GRAY2, mobileMedia, WHITE} from '../../../globalVariables/GlobalVariables';
import {btn} from '../../button/btn/Btn.css';
import {justifyBetween} from '../../../globalVariables/GlobalFlex';

export const bottom = styled(warpButtons)`
    inset-inline-end: 0;
    inset-inline-start: 0;
    width: 100%;
    padding-top: 10px;
    border-top: 1px solid ${LIGHT_GRAY2};
    padding-inline: 30px;
    ${justifyBetween};
    align-items: center;
    background-color: ${WHITE};
    ${btn}{
        margin: 0;
        padding: 12px 25px;
        font-weight: 700;
    }
    ${mobileMedia}{
        height: 100px;
        padding-inline: 20px;
    }
`;

export const privateText = styled.div`
    >span{
        font-weight: 700;
        margin-inline-end: 5px;
    }
    height: max-content;
    margin-inline-start: 10px;
    margin-inline-end: auto;
    ${mobileMedia}{
        margin-inline: 0;
    }
`;
